module.exports = __webpack_public_path__ + "static/media/eyeSquintLeft.cc65a964.obj";